import { RemoteData } from 'app/infrastructure/remote-data';
import { CodetableWireFormat } from 'app/infrastructure/ui/form/types-codetable';

const endpoint = {
  contextDetails: 'contextDetails'
};

interface ContextDetails {
  language: CodetableWireFormat;
}

export const api = {
  /**
   * Fetches language to use for text collections in anonymous client
   */
  getContextDetails: async (): Promise<ContextDetails> => {
    const remote = new RemoteData(endpoint.contextDetails);
    return await remote.resource<ContextDetails>().single();
  }
};
